import { useEffect, useState } from "react";
import { EcgDetailsContextProvider } from "../../context/EcgDetailsContext";
import useResponsive from "../../hooks/useResponsive";
import { IBaseEcg } from "../../models/base-ecg.interface";
import { IBaseUser } from "../../models/base-user.interface";
import EcgDetails from "../EcgDetails/EcgDetails";
import styles from "./UserEcgs.module.css";
import UserEcgsHeader from "./UserEcgsHeader/UserEcgsHeader";
import UserEcgsList from "./UserEcgsList/UserEcgsList";

type UserEcgsProps = {
  showList?: boolean;
  user?: IBaseUser | null;
  selectedEcg?: IBaseEcg | null;
  breadcrumbs?: string[];
  minGraphWidth?: number;
  onEcgUpdate: (reselectEcg?: boolean) => void;
  onEcgReviewLock?: (ecgId: string | null) => void;
  onBack: () => void;
};

const UserEcgs = ({
  showList,
  selectedEcg,
  user,
  breadcrumbs,
  minGraphWidth,
  onEcgUpdate,
  onBack,
  onEcgReviewLock,
}: UserEcgsProps) => {
  const [userSelectedEcg, setUserSelectedEcg] = useState(selectedEcg);

  const [ecgMetaOpenOnMobile, setEcgMetaOpenOnMobile] = useState(false);

  const { isMobile } = useResponsive();

  const backHandler = () => {
    if (ecgMetaOpenOnMobile) {
      setEcgMetaOpenOnMobile(false);
      return;
    }

    if (onBack) onBack();
  };

  useEffect(() => {
    if (!isMobile && ecgMetaOpenOnMobile) {
      setEcgMetaOpenOnMobile(false);
    }
  }, [isMobile, ecgMetaOpenOnMobile]);

  return (
    <EcgDetailsContextProvider
      selectedEcg={selectedEcg ?? null}
      patientId={user?.id ?? null}
    >
      <div className="d-flex flex-column h-100 w-100">
        <UserEcgsHeader
          user={user ?? null}
          breadcrumbs={breadcrumbs ?? null}
          minGraphWidth={minGraphWidth}
          onBack={backHandler}
        />
        <div className="d-flex flex-grow-1 overflow-hidden">
          {showList && (
            <div className={styles.ecgsWrapper}>
              <UserEcgsList
                selectedEcgId={userSelectedEcg?.id}
                selectedPatientId={user?.id ?? null}
                onSelectEcg={(ecg: IBaseEcg) => setUserSelectedEcg(ecg)}
              />
            </div>
          )}
          <div className={`${styles.ecgDetailsWrapper} flex-grow-1 w-100`}>
            <EcgDetails
              minGraphWidth={minGraphWidth}
              onEcgUpdate={onEcgUpdate}
              onEcgReviewLock={onEcgReviewLock}
              showEcgMetaOnMobile={ecgMetaOpenOnMobile}
              onToggleEcgMetaOnMobile={(isOpen) =>
                setEcgMetaOpenOnMobile(isOpen)
              }
            />
          </div>
        </div>
      </div>
    </EcgDetailsContextProvider>
  );
};

export default UserEcgs;
